document.addEventListener("DOMContentLoaded", function () {
  const maxSelection = 4;

  function updateSelectedOptions() {
    const allCheckboxes = document.querySelectorAll("input[type='checkbox']");
    
    const checkedCheckboxes = Array.from(allCheckboxes).filter((cb) => cb.checked);

    if (checkedCheckboxes.length >= maxSelection) {
      allCheckboxes.forEach((cb) => {
        if (!cb.checked) cb.disabled = true;
      });
    } else {
      allCheckboxes.forEach((cb) => {
        cb.disabled = false;
      });
    }

    allCheckboxes.forEach((checkbox) => {
      const parentLabel = checkbox.closest('label');
      const checkmark = parentLabel.querySelector('.checkmark');

      if (checkbox.checked) {
        console.log(checkbox)
        parentLabel.classList.add('selected');
        checkmark.style.display = 'block';
      } else {
        parentLabel.classList.remove('selected');
        checkmark.style.display = 'none';
      }
    });
  }

  const allCheckboxes = document.querySelectorAll("input[type='checkbox']");
  allCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", updateSelectedOptions);
  });

  updateSelectedOptions();
});


document.addEventListener("DOMContentLoaded", function() {  
  let counter = 0 ;
  let maximumCounter = document.getElementById("maximum_counter");
  let previewBox = document.getElementById('preview_box');
  let radioInputs = document.querySelectorAll("input[type='checkbox']"); 
  console.log("radioInputs")
  let limit  = 4; 
  for(let i = 0 ; i < radioInputs.length; i++){
    let clicked = radioInputs[i]
    console.log(clicked)
    clicked.addEventListener('click' , () => {
      console.log("hhhheeellllpppppp")
      if(clicked.checked){
        console.log("First " + clicked.checked)
        limitSet(clicked)
      }
      else if(!clicked.checked){
        console.log("Second " + clicked.checked)
        removeVariant(clicked)
      }
      console.log("TestingSetup")
      console.log(maximumCounter)
      maximumCounter.children[1].innerText = counter
    })
  }


  // add Element in preview Box
  let selectedVariants = [];
  let selectedVariants2 = [];
  function limitSet(currentElement){
    console.log("sssss", currentElement);
    let div = document.createElement("div");
    div.setAttribute("class", "variant_box");
    if(counter < limit){
        counter ++
        let parentEle = currentElement.closest('.productoptionswatchwrapper')
        let mainDiv = currentElement.closest('.options__swatch-container')
        let img = parentEle.querySelector('img').src
        let category = mainDiv.querySelector('.option_title').innerText
        let variantValue = parentEle.querySelector('.swatch-variant-title').innerText
        let variantField = parentEle.querySelector('.swatch-variant-title')
        const payload = {
          id: variantField.getAttribute('data-id'),
          productName: variantValue,
          sku: variantField.getAttribute('data-sku'),
          type: variantField.getAttribute('data-type')
        }
        const payload2 = variantField.getAttribute('data-sku')+"_"+variantValue
        selectedVariants.push(payload);
        selectedVariants2.push(payload2);
      
        div.innerHTML = `
          <div class="variant_images_text">
            <div class="image_box">
              <img src="${img}" alt="${variantValue}">
            </div>
            <div class="detailed_box">
                <span>${category}</span>
                <span class="${currentElement.value}">${variantValue}</span>
            </div>
          </div>`
        previewBox.appendChild(div)
        const noteIdea = document.querySelector('#cart_note');
        noteIdea.value = JSON.stringify(selectedVariants);

        // const noteIdea2 = document.querySelector('#cart_note2');
        // noteIdea2.value = JSON.stringify(selectedVariants2);
    }else{
     currentElement.checked = false
    }
  }

// remove element from preview box
function removeVariant(current) {
    console.log("Current value:", current.value);

    const parentEle = current.closest('.productoptionswatchwrapper');
    if (!parentEle) {
        console.log("Parent element not found");
        return;
    }

    const variantField = parentEle.querySelector('.swatch-variant-title');
    if (!variantField) {
        console.log("Variant field not found");
        return;
    }

    const currentId = variantField.getAttribute('data-id');
    console.log("Current ID:", currentId);

    // Filter selectedVariants and update
    selectedVariants = selectedVariants.filter(item => item.id !== currentId);
    document.querySelector('#cart_note').value = JSON.stringify(selectedVariants);
    console.log("Updated selectedVariants:", selectedVariants);

    // // Filter selectedVariants2 and update
    // const variantValue = current.value.split(",")[1];
    // selectedVariants2 = selectedVariants2.filter(item => item.split("_")[0] !== variantValue);
    // document.querySelector('#cart_note2').value = JSON.stringify(selectedVariants2);
    // console.log("Updated selectedVariants2:", selectedVariants2);

    // Remove the corresponding element from the preview box
    const selectedList = document.querySelectorAll('.variant_box');
    console.log("Selected list:", selectedList);

    selectedList.forEach(parsentValue => {
        const variantClass = parsentValue.querySelector('.detailed_box').children[1].className;
        console.log("Checking variantClass:", variantClass);

        if (current.value === variantClass) {
            console.log("Removing element:", parsentValue);
            parsentValue.remove();
            counter--;  // Ensure counter is declared and updated elsewhere
            console.log("Updated counter:", counter);
            maximumCounter.children[1].innerText = counter;  // Update counter display
        }
    });
}

})

// async function fetchCartNote() {
//   const resp = await fetch('/cart.js');
//   const response = await resp.json();
//   const cartNote = response.note;
//   console.log("note", cartNote);
//   return cartNote
// }

// fetchCartNote();

window.addEventListener('beforeunload', () => {
  let radioInputs = document.getElementsByClassName("avp-productoptiontextcolor"); 
  for(let i = 0; i < radioInputs.length; i++){
    let checkedBtn = radioInputs[i]
    if(checkedBtn.checked){
      checkedBtn.checked = false;
    }
  }
  setTimeout(() => {
    previewBox.innerHTML = " "   
    counter = 0;
    maximumCounter.children[1].innerText = counter
  },2000)
});